import { fork, all } from 'redux-saga/effects';
import watchRequestUserLocale from './requestUserLocale/requestUserLocale';
import watchRequestLogoutUser from './logoutUser/logoutUser';
import watchFetchUserInfo from '../shared/sagas/userInfo/userInfo';
import watchUserDropdownSaga from './userDropdownSaga/userDropdownSaga';
import watchFetchNavOptions from './navigationOptions/navigationOptions';

export default function* rootSaga() {
    yield all([
        fork(watchRequestUserLocale),
        fork(watchRequestLogoutUser),
        fork(watchFetchUserInfo),
        fork(watchFetchNavOptions),
        fork(watchUserDropdownSaga),
    ]);
}
